import { render, staticRenderFns } from "./newRightLogin.vue?vue&type=template&id=b39bebe2&scoped=true"
import script from "./newRightLogin.vue?vue&type=script&lang=js"
export * from "./newRightLogin.vue?vue&type=script&lang=js"
import style0 from "./newRightLogin.vue?vue&type=style&index=0&id=b39bebe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39bebe2",
  null
  
)

export default component.exports